import { Tx_Inst_Property } from '../models/domain/tx_inst_property';

export class Tx_Inst_PropertiesUtil {
    private static instance: Tx_Inst_PropertiesUtil;

    static getInstance(): Tx_Inst_PropertiesUtil {
        if (!Tx_Inst_PropertiesUtil.instance) {
            Tx_Inst_PropertiesUtil.instance = new Tx_Inst_PropertiesUtil();
        }
        return Tx_Inst_PropertiesUtil.instance;
    }

    /**
     * Tx_Inst_PropertiesUtil is a singleton class, so use Tx_Inst_PropertiesUtil.getInstance() method instead of creating new Tx_Inst_PropertiesUtil().
     */
    private constructor() {

    }

    copy(tx_Inst_Properties: Array<Tx_Inst_Property>): Array<Tx_Inst_Property> {
        let tx_Inst_PropertiesCopy: Array<Tx_Inst_Property> = new Array<Tx_Inst_Property>();

        for (let i: number = 0; i < tx_Inst_Properties.length; i++) {
            let tx_Inst_Property: Tx_Inst_Property = tx_Inst_Properties[i] as Tx_Inst_Property;
            tx_Inst_PropertiesCopy.push(tx_Inst_Property.copy())
        }
        return tx_Inst_PropertiesCopy;
    }

    copyFrom(tx_Inst_Properties: Array<Tx_Inst_Property>, tx_Inst_PropertiesTmp: Array<Tx_Inst_Property>): void {
        let tx_Inst_PropertiesMap: Map<number, Tx_Inst_Property> = new Map();

        for (let i: number = 0; i < tx_Inst_Properties.length; i++) {
            let tx_Inst_Property: Tx_Inst_Property = tx_Inst_Properties[i] as Tx_Inst_Property;
            tx_Inst_PropertiesMap.set(tx_Inst_Property.dxMp_Id, tx_Inst_Property);
        }

        tx_Inst_Properties.splice(0, tx_Inst_Properties.length);

        for (let i: number = 0; i < tx_Inst_PropertiesTmp.length; i++) {
            let tx_Inst_PropertyTmp: Tx_Inst_Property = tx_Inst_PropertiesTmp[i] as Tx_Inst_Property;

            let tx_Inst_Property: Tx_Inst_Property = tx_Inst_PropertiesMap.get(tx_Inst_PropertyTmp.dxMp_Id);
            if (tx_Inst_Property) {
                tx_Inst_Property.copyFrom(tx_Inst_PropertyTmp);
            } else {
                tx_Inst_Property = Tx_Inst_Property.parse(tx_Inst_PropertyTmp);
            }
            tx_Inst_Properties.push(tx_Inst_Property);
        }
    }

    compare(tx_Inst_Properties: Array<Tx_Inst_Property>, tx_Inst_PropertiesTmp: Array<Tx_Inst_Property>): string {
        let tx_Inst_PropertiesLength = tx_Inst_Properties.length;
        let tx_Inst_PropertiesTmpLength = tx_Inst_PropertiesTmp.length;

        if (tx_Inst_PropertiesLength != tx_Inst_PropertiesTmpLength) {
            return 'Tx_Inst_Properties length is different.';
        }
        let tx_Inst_PropertiesTmpMap: Map<number, Tx_Inst_Property> = new Map<number, Tx_Inst_Property>();
        for (let i: number = 0; i < tx_Inst_PropertiesTmpLength; i++) {
            let tx_Inst_PropertyTmp: Tx_Inst_Property = tx_Inst_PropertiesTmp[i] as Tx_Inst_Property;
            tx_Inst_PropertiesTmpMap.set(tx_Inst_PropertyTmp.dxMp_Id, tx_Inst_PropertyTmp);
        }

        for (let i: number = 0; i < tx_Inst_PropertiesLength; i++) {
            let tx_Inst_Property: Tx_Inst_Property = tx_Inst_Properties[i] as Tx_Inst_Property;

            let tx_Inst_PropertyCopy: Tx_Inst_Property = tx_Inst_PropertiesTmpMap.get(tx_Inst_Property.dxMp_Id);
            if (!tx_Inst_PropertyCopy) {
                return tx_Inst_Property.property_Nm + ' DxMp_Id is found in copy.'
            }
            if (tx_Inst_Property.compare(tx_Inst_PropertyCopy) != '') {
                return tx_Inst_Property.property_Nm + ' DxMp_Id is not equal.'
            }
        }
        return '';
    }

    toString(tx_Inst_Properties: Array<Tx_Inst_Property>): string {
        let str: string = '';
        str += 'Tx_Inst_Properties length: ' + tx_Inst_Properties.length + ' ';

        for (let i: number = 0; i < tx_Inst_Properties.length; i++) {
            let tx_Inst_PropertyTmp: Tx_Inst_Property = tx_Inst_Properties[i] as Tx_Inst_Property;
            str += tx_Inst_PropertyTmp.toString();
        }
        return str;
    }

}